import React from 'react';
import { Spinner } from 'components/atoms';
import BasicCrud   from 'components/basicCrud';
import Breed         from 'services/Breed';
import { fciGroups } from 'services/constants'; 
import RemoveButton from 'components/RemoveButton';

function Item(props) {
  let {item, editHook} = props;
  let edit = () => {
    editHook(item.id);
  }
  return (
    <button onClick={edit} id={item.id} title="Кликните для редактирования" className="list-group-item list-group-item-action">
      <h5><strong className="ms-3" title="Группа FCI">{item.fci_group}</strong>
          &nbsp;/&nbsp;
          <span title="Номер FCI">{item.fci_num}</span>.&nbsp;-&nbsp;
          <span title="Название" className="me-4">{item.name} / {item.name_lat}</span> 
         
      </h5>
      <p className="mb-1"><strong className="me-2">Собак в породе: </strong>{item.dogs_count}</p>
    </button>
  );
}

function ItemEdit(props) {
  let {item, updateAttribute, save, cancel, remove, saving} = props;
  return (
    <form id={item.id} className="list-group-item">
      <h3>Редактировать запись</h3>
      <div className="mb-3">
        <label htmlFor="itemName">Название</label>
        <input type="text" className="form-control" id="itemName" name="name" value={item.name} onChange={updateAttribute}/>
      </div>
      <div className="mb-3">
        <label htmlFor="itemNameLat">Name</label>
        <input type="text" className="form-control" id="itemNameLat" name="name_lat" value={item.name_lat} onChange={updateAttribute}/>
      </div>
      <div className="mb-3">
        <label htmlFor="itemFciNum">Номер породы по FCI</label>
        <input type="number" className="form-control" id="itemFciNum" name="fci_num" value={item.fci_num} onChange={updateAttribute}/>
      </div>
      <div className="mb-3">
        <label htmlFor="itemFciGroup">Группа FCI</label>
        <select className="form-select" id="itemFciGroup" name="fci_group" value={item.fci_group} onChange={updateAttribute} >
          <option value="">Выберите</option>
          {fciGroups.map(group => <option key={group.id} value={group.id}>{group.name}</option>)}
        </select>
      </div>
      <div className="mb-2">
        <button type="button" disabled={saving} onClick={save} className="btn btn-primary me-2">
          { (saving && <Spinner />) }
          Сохранить
        </button>
        <button disabled={saving} type="button" onClick={cancel} className="btn btn-light">Отмена</button>
        <RemoveButton disabled={saving} remove={remove} />
      </div>
    </form>
  );
}


export default class Breeds extends BasicCrud {

  constructor(props) {
    super(props);
    this.listName = 'Породы';
    this.modelClass = Breed;
    this.filterFields = [
      {
        name: 'name',
        label: 'Название',
        className: 'col-6',
      },
      {
        name: 'name_lat',
        label: 'Name',
        className: 'col-6',
      },
      {
        name: 'fci_num',
        label: 'Номер по FCI',
        className: 'col-3',
      },
      {
        name: 'fci_group',
        label: 'Группа по FCI',
        className: 'col-3',
      }
    ];
    this.state.filter = {
      name: '',
      fci_num: '',
      fci_group: '',
    };
  }

  renderItem = (item) => {
    if ( this.state.currentEditedItem === item.id ) {
      return <ItemEdit item={item}
        key={item.id}
        updateAttribute={this.itemUpdateAttribute}
        save={this.saveCurrentItem}
        cancel={this.cancelEditItem}
        remove={this.removeCurrentItem}
        saving={this.state.saving}
        />
    }
    return <Item item={item} editHook={this.editItem} key={item.id}/>
  }

}
